import React from "react";
import styled from "styled-components";
import { Link } from "react-router";

const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
`;

const BreadcrumbItem = styled(Link)`
  color: #005856;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

const CurrentItem = styled.span`
  color: #005856;
`;

const Separator = styled.span`
  color: #005856;
`;

const Breadcrumb = ({ items }) => {
  return (
    <BreadcrumbContainer>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <Separator>&gt;</Separator>}
          {index === items.length - 1 ? (
            <CurrentItem>{item.label}</CurrentItem>
          ) : (
            <BreadcrumbItem to={item.path}>{item.label}</BreadcrumbItem>
          )}
        </React.Fragment>
      ))}
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
